import { useContext, useState, useRef } from 'react'
import { ThemeContext } from 'modules/Theme'
import classNames from 'classnames'
import Text from 'components/Text'
import Button from 'components/Button'
import If from '@mobi/components/If'
import useMediaQuery from 'hooks/useMediaQuery'
import useCountdownTimer from 'hooks/useCountdownTimer'
import useHasMounted from 'hooks/useHasMounted'
import LandingHeroForm from './Form'
import './LandingHero.scss'
import CountDownLP from './CountDown'

const countDownData = {
  startDate: new Date(`Mon Aug 28 2023 00:00:01 GMT-0300`).getTime(),
  endDate: new Date(`Mon Aug 28 2023 00:00:01 GMT-0300`).getTime(),
  title: '',
  boldText: '',
}

const holidayDisclamerText = ''

const LandingHero = ({ location }) => {
  const [isFormOpen, setIsFormOpen] = useState(false)

  const formikRef = useRef(null)
  const refRecaptchaReneg = useRef(null)

  const isDesktop = useMediaQuery('desktop')
  const { theme } = useContext(ThemeContext)
  const { hasMounted } = useHasMounted()
  const targetDate = useCountdownTimer(countDownData.endDate)

  const isRecoveryOrigin = theme === 'recovery'

  const isCountDownRunning = targetDate?.some((value) => value > 0)

  const isHoliday = true

  const handleReturnToFirstStepForm = () => {
    formikRef.current.resetForm()

    setTimeout(() => {
      setIsFormOpen(false)
    }, 100)
  }

  return (
    <>
      <div
        className={classNames('landing-hero', {
          'landing-hero--holiday': isHoliday,
          'with-disclamer': !!holidayDisclamerText,
        })}
        data-test="container-hero"
      >
        <div
          className={classNames('left-part', {
            'left-part--holiday': isHoliday,
            'left-part--is-form-open': isFormOpen,
          })}
        >
          <If
            condition={(isDesktop && !isFormOpen) || !isDesktop}
            renderIf={
              <>
                <Text
                  h2
                  size={1}
                  className={classNames('label-text', {
                    'label-text--holiday': isHoliday,
                  })}
                >
                  negocie dívidas online
                </Text>
                <div
                  className={classNames('main-text', {
                    'main-text--holiday': isHoliday,
                  })}
                >
                  <Text h1 size={3} className="title-text">
                    <If
                      condition={isHoliday}
                      renderIf={
                        <>
                          Faça a renegociação <br />
                          das suas dívidas com <br />
                          até 99% de desconto
                        </>
                      }
                      renderElse={
                        <>
                          Renegocie suas <br /> dívidas{' '}
                          <span className="title-text__emphasis-text">
                            com até 98%
                          </span>{' '}
                          <br />{' '}
                          <span className="title-text__emphasis-text">
                            de desconto
                          </span>
                        </>
                      }
                    />
                  </Text>
                  <Text p size={3} className="sub-text">
                    <If
                      condition={isHoliday}
                      renderIf={<></>}
                      renderElse={<></>}
                    />
                  </Text>
                </div>
              </>
            }
          />

          {hasMounted && (
            <If
              condition={isRecoveryOrigin && isCountDownRunning}
              renderIf={
                <If
                  condition={Date.now() >= countDownData.startDate}
                  renderIf={
                    <CountDownLP data={countDownData} targetDate={targetDate} />
                  }
                />
              }
            />
          )}
          <div
            className={classNames('form-section', {
              'form-section--holiday': isHoliday,
            })}
          >
            <If
              condition={isDesktop && isFormOpen}
              renderIf={
                <>
                  <Button
                    ghost
                    className="hero-left-part__button"
                    onClick={() => handleReturnToFirstStepForm()}
                    icon="left"
                  >
                    Voltar
                  </Button>
                  <Text
                    p
                    size={3}
                    className="hero-left-part__description-form-text"
                  >
                    Para consultar suas dívidas, precisamos das seguintes
                    informações:
                  </Text>
                </>
              }
            />
            <LandingHeroForm
              location={location}
              isHeroFormOpen={isFormOpen}
              setIsHeroFormOpen={setIsFormOpen}
              refRecaptchaReneg={refRecaptchaReneg}
              formikRef={formikRef}
            />
          </div>
        </div>
      </div>

      <If
        condition={holidayDisclamerText}
        renderIf={
          <Text p className="banner-campaign-text">
            {holidayDisclamerText}
          </Text>
        }
      />
    </>
  )
}

export default LandingHero
